module.exports = __webpack_public_path__ + "static/img/bonus.afbf787.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bonus.jpg
// module id = UrzX
// module chunks = 1